import React from 'react';
import { useI18n } from '../contexts/I18nContext';

export const LoadingPage: React.FC = () => {
  const { t } = useI18n();
  return (
        <div className="auth-loading-page">
          <div className="loading-container">
            <div className="loading-spinner"></div>
            <p>{t('common.loading')}</p>
          </div>
        </div>
      );
};